var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 192C259.375 192 288 163.375 288 128S259.375 64 224 64S160 92.625 160 128S188.625 192 224 192ZM224 80C250.467 80 272 101.533 272 128S250.467 176 224 176S176 154.467 176 128S197.533 80 224 80ZM440 248H8C3.578 248 0 251.594 0 256S3.578 264 8 264H440C444.422 264 448 260.406 448 256S444.422 248 440 248ZM224 320C188.625 320 160 348.625 160 384S188.625 448 224 448S288 419.375 288 384S259.375 320 224 320ZM224 432C197.533 432 176 410.467 176 384S197.533 336 224 336S272 357.533 272 384S250.467 432 224 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide);
export default __webpack_public_path__ + "static/media/divide.bf04df2369eaf5ba4b7695e517483408.svg";
export { ForwardRef as ReactComponent };